import {Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {ChaptersResultsLineService} from './chaptersResultsLine.service';
import {STATE_NAMES} from "../../../primoExplore/primoExploreStates.module";
import {ChaptersAndReviewsService} from "../../chaptersAndReviews/chaptersAndReviews.service";
import {PrimoResponse} from "../../../infra/dataStructures/PrimoResponses/doc.interfcae";
import {SeedData} from "../../citationTrails/citationTrailsBreadcrumbs.directive";
import {beacon, PrimolyticsService} from "../../../analytics/primolytics.service";
import {isCDI} from "../../../appConfig/appConfigForward";
import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';

const get = require('lodash/get');

@Component({
    selector: 'prm-chapters-results-line',
    templateUrl: 'components/search/searchResult/searchResultsChaptersAndReviews/chapters-results-line.html',
})

export class PrmChaptersResultsLine implements OnInit {

    @Input() item: PrimoResponse.IDoc;

    public CHAPTERS_STATE = STATE_NAMES.CITATION_CHAPTERS;

    constructor(private chaptersResultsLineService: ChaptersResultsLineService,
                private chaptersAndReviewsService: ChaptersAndReviewsService,
					                private configurationUtil : ConfigurationUtil,
                private primolyticsService: PrimolyticsService,
                @Inject('searchBoxIcons') private searchBoxIcons: Object[],
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService,
                @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService) {
    }

    ngOnInit() {
	
    }

    public onClick($event, type) {
        this.sendBeacon(type);
        $event.stopPropagation();
        this.chaptersAndReviewsService.item = this.item;

        this.$mdDialog.hide();
        if (this.$state.current.name === this.CHAPTERS_STATE){
            $event.preventDefault();
            let data = this.chaptersStateParams(type);
            this.$rootScope.$broadcast('addChaptersEvent', {params: data});/*this event bubbles. Maybe there is an angular 2 way to do this?
            I had to use a broadcast from the root scope since I need to catch events fired from within the full view md-dialog*/
        }else{}
    }

    public sendBeacon(type) {
        if (type === 'chapters') {
            if (this.isBookChapterRecordType()) {
                this.sendChaptersSameBookBeacon(this.item);
            } else if (this.isBookRecordType()) {
                this.sendBookChaptersBeacon(this.item);
            }
        } else if (type === 'reviews') {
            this.sendBookReviewsBeacon(this.item);
        }
    }

    @beacon({'p': 'linksService', 'op': 'relatedItemsChaptersSameBook', 'item': 'item'})
    private sendChaptersSameBookBeacon(item) {
    }

    @beacon({'p': 'linksService', 'op': 'relatedItemsBookChapters', 'item': 'item'})
    private sendBookChaptersBeacon(item) {
    }

    @beacon({'p': 'linksService', 'op': 'relatedItemsBookReviews', 'item': 'item'})
    private sendBookReviewsBeacon(item) {
    }

    public chaptersStateParams(type) {
        let facetType = 'frbrgroupid';
        let frbrgroupid = this.chaptersAndReviewsService.chaptersFrbrGroupId(this.item);

        let multiFacets = [];
        if (type === 'chapters') {
            multiFacets = this.chaptersAndReviewsService.multiFacetsBookChapter(frbrgroupid);

        }
        if (type === 'reviews') {
            multiFacets = this.chaptersAndReviewsService.multiFacetsBookReviews(frbrgroupid);
        }

        let record_id='';
        if (this.configurationUtil.isSuprima() && this.item.pnx.search){
            record_id=this.item.pnx.search.recordid[0];
        } else if (this.item.pnx.control){
            record_id=this.item.pnx.control.recordid[0];
        }


        let params = {
            query: this.$stateParams.query || 'any,contains,' + record_id,
            tab: this.$stateParams.tab,
            type: type,
            search_scope: this.$stateParams.search_scope,
            lang: this.$stateParams.lang,
            adaptor: this.$stateParams.adaptor,
            vid: this.$stateParams.vid,
            mfacet: multiFacets,
            docid: record_id,
            isRelatedItems: true,
            isCDI: isCDI(),
            context: get(this.item,'context')

        };
        return params;
    }

    private isBookChapterRecordType() {
        /*return this.item.pnx.search.rsrctype['book_chapter'];*/
        return get(this.item, 'pnx.display.type[0]','b').toLowerCase() === 'book_chapter';
    }

    private isBookRecordType() {
        /*return this.item.pnx.search.rsrctype['book'];*/
        return get(this.item, 'pnx.display.type[0]','b').toLowerCase() === 'book';
    }

    private getBookChapters() {
        let frbrgroupid = get(this.item, 'pnx.facets.frbrgroupid[0]');
        return this.chaptersAndReviewsService.getBookChapters(frbrgroupid);
    }

    private getBookReviews() {
        let frbrgroupid = get(this.item, 'pnx.facets.frbrgroupid[0]');
        return this.chaptersAndReviewsService.getBookReviews(frbrgroupid);
    }

    private getNumberOfChapters() {
        let bookChapters = this.chaptersAndReviewsService.getBookChapters(this.item.pnx.facets.frbrgroupid[0]);
        return get(bookChapters, 'numOfGroupIds');
    }

    private getNumberOfReviews() {
        let bookReviews = this.chaptersAndReviewsService.getBookReviews(this.item.pnx.facets.frbrgroupid[0]);
        return get(bookReviews, 'numOfGroupIds');
    }

    private getNumberOfChaptersPlaceHolder(){
        return {counter:this.getNumberOfChapters()};
    }

    private getChaptersCode( ){
        if (this.isBookRecordType()) {
            return 'nui.results.relatedItems.book2chapter.link';
        }
        return 'nui.results.relatedItems.chapter2chapter.link';
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultsChaptersAndReviews/chaptersResultsLine.directive.ts